module.exports = __webpack_public_path__ + "media/images/iheart-ce98574f4246874141f797ba909b36fd.png";